import { jsxs, jsx } from "react/jsx-runtime";
import { css } from "@/styled-system/css";
import { Heading } from "@zillow/constellation-10";
import parse from "html-react-parser";
const AI_SUMMARY_HEADINGS = {
  keyTakeaways: "Key takeaways",
  articleSummary: "Article summary"
};
const containerClass = css({
  backgroundColor: "gray.50",
  borderRadius: "obj.default",
  padding: {
    base: "default",
    md: "loose"
  },
  marginBottom: "loose"
});
const headingClass = css({
  marginBottom: "tight"
});
const contentClass = css({
  fontSize: "body",
  lineHeight: "body",
  color: "text.neutral",
  "& p": {
    margin: 0
  },
  "& ul": {
    display: "flex",
    flexDirection: "column",
    gap: "tighter",
    margin: 0,
    paddingLeft: "loose"
  },
  "& li": {
    margin: 0
  }
});
const MARKDOWN_BOLD = /\*\*([^*]+)\*\*/g;
function markdownBoldToHtml(html) {
  return html.replace(MARKDOWN_BOLD, (_, text) => `<strong>${text}</strong>`);
}
function isRenderableDisplayType(value) {
  return value === "keyTakeaways" || value === "articleSummary";
}
const HTML_TAG = /<[^>]*>/g;
const HTML_WHITESPACE_ENTITY = /&(?:nbsp|ensp|emsp|thinsp|#160|#x[aA]0|#8194|#8195|#8201);/g;
function hasText(html) {
  return Boolean(html && html.replace(HTML_TAG, "").replace(HTML_WHITESPACE_ENTITY, " ").trim());
}
const AISummary = ({
  bullets,
  paragraph,
  displayType,
  className,
  headingLevel = 2
}) => {
  if (!isRenderableDisplayType(displayType)) {
    return null;
  }
  const html = displayType === "keyTakeaways" ? bullets : paragraph;
  if (!hasText(html)) {
    return null;
  }
  const heading = AI_SUMMARY_HEADINGS[displayType];
  return /* @__PURE__ */ jsxs("aside", { "aria-label": heading, className: [containerClass, className].filter(Boolean).join(" "), "data-display-type": displayType, children: [
    /* @__PURE__ */ jsx(Heading, { level: headingLevel, textStyle: "heading-sm", className: headingClass, children: heading }),
    /* @__PURE__ */ jsx("div", { className: contentClass, children: parse(markdownBoldToHtml(html)) })
  ] });
};
export {
  AI_SUMMARY_HEADINGS,
  AISummary as default,
  markdownBoldToHtml
};
